export const getPlatform = (): string => {
  let platform = ''

  if (!platform) {
    platform = /iPhone|iPod|Android/i.test(navigator.userAgent)
      ? 'mobile'
      : 'desktop'
  }

  return platform
}

export const getPlatformTriState = (): string => {
  let platform = ''

  if (!platform) {
    if (/iPhone|iPod|Android/i.test(navigator.userAgent)) {
      platform = 'mobile'
    } else if (/iPad/i.test(navigator.userAgent)) {
      platform = 'tablet'
    } else {
      platform = 'desktop'
    }
  }
  return platform
}
